const NG_DOC_STORE_THEME_KEY = 'ng-doc-theme-id';

/**
 * Generated bundle index. Do not edit.
 */

export { NG_DOC_STORE_THEME_KEY };
